import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";
import Vue from "vue";

export const departmentProcess = createCrudVuexModule({
  namespaced: true,
  path: "/quick-hierarchy/department-process",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async create({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.post(`/quick-hierarchy/department-process`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        commit("isUpdating", true);
        payload = await dispatch("preparePayload", {
          editedEntity: getters.editedEntity,
          form: payload,
        });

        const response = await rest.put(`/quick-hierarchy/department-process`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/quick-hierarchy/department-process/${item._id}`);
          success.push(Vue.filter("translate")(item.department.name) + "-" + Vue.filter("translate")(item.process.name));
        } catch (error) {
          failed.push({ name: Vue.filter("translate")(item.department.name) + "-" + Vue.filter("translate")(item.process.name), error: error.data.message });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});

export const workspaceDepartmentProcess = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/quick-hierarchy/department-process",

  state: {
    editedEntity: undefined,
  },
  getters: {
    copingEntity: (state) => state.copingEntity ?? {},
  },
  actions: {
    async save({ dispatch, getters }, payload) {
      payload = await dispatch("preparePayload", {
        editedEntity: getters.editedEntity,
        form: payload,
      });

      if (payload._id) {
        return dispatch("update", payload);
      } else {
        return dispatch("create", payload);
      }
    },
    async create({ getters, commit, dispatch }, payload) {
      try {
        const response = await rest.post(`/workspace/quick-hierarchy/department-process`, payload);
        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async update({ getters, commit, dispatch }, payload) {
      try {
        const response = await rest.put(`/workspace/quick-hierarchy/department-process`, payload);

        commit("editedEntity", undefined);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async multipleDelete({ state, commit }, array) {
      const success = [];
      const failed = [];

      for (const item of array) {
        try {
          await rest.delete(`/workspace/quick-hierarchy/department-process/${item._id}`);
          success.push(Vue.filter("translate")(item.department.name) + "-" + Vue.filter("translate")(item.process.name));
        } catch (error) {
          failed.push({ name: Vue.filter("translate")(item.department.name) + "-" + Vue.filter("translate")(item.process.name), error: error.data.message });
        }
      }

      commit("deleteOperationResult", {
        success: success,
        failed: failed,
      });
    },
  },
});
